import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reimpostata. Accedi ora.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <img src="/ptmed-logo-dark.jpg" alt="PT-MED" className="h-14 w-14 rounded-xl object-cover mx-auto mb-6" />
        <h2 className="font-heading text-2xl font-bold text-center">Nuova password</h2>
        <p className="text-sm text-muted-foreground text-center mt-1 mb-8">Scegli una nuova password sicura.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="password">Nuova password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                   required minLength={6} data-testid="reset-password-input" className="mt-1.5 h-11" />
          </div>
          <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="w-full h-11 font-semibold">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Reimposta password
          </Button>
        </form>
        <Link to="/login" className="mt-6 inline-flex items-center text-sm text-primary hover:underline">
          <ArrowLeft className="mr-1 h-4 w-4" /> Torna al login
        </Link>
      </div>
    </div>
  );
}
